"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var NumberingStyleConverter = /** @class */ (function () {
    function NumberingStyleConverter() {
    }
    NumberingStyleConverter.covert = function (numberingStyle) {
        if (numberingStyle == null) {
            return null;
        }
        var numberingStyleDto = new idm_report_export_service_client_js_1.NumberingStyleDto();
        numberingStyleDto.format = numberingStyle.format;
        return numberingStyleDto;
    };
    return NumberingStyleConverter;
}());
exports.NumberingStyleConverter = NumberingStyleConverter;
//# sourceMappingURL=numbering-style-converter.js.map